<ng-container *ngIf="routes$; then routesThen else routesElse"></ng-container>

<ng-template #routesThen>
	<div class="menu">
		<div class="menu-header">
			<button mat-button class="appname" routerLink="/">{{title}}</button>

			<div class="divider"></div>
		</div>

		<div class="menu-navigation">
			<div #menuItems class="menu-items" (scroll)="atualizarSetasMenu()">
				<ng-container *ngFor="let route of routes$ | async">
					<button mat-button class="navitem" [routerLink]="route.route" [class.active]="isRouteActive(route)">
						<mat-icon>{{route.icon}}</mat-icon>
						<span class="navname">{{route.name}}</span>
					</button>
				</ng-container>
			</div>
			<button *ngIf="podeRolarMenuParaEsquerda" type="button" class="menu-scroll-control mobile-menu-scroll-control menu-scroll-left"
				(mouseenter)="iniciarRolagemMenuHorizontal(-1)" (mouseleave)="pararRolagemMenu()"
				aria-label="Rolar menu para a esquerda">
				<mat-icon>keyboard_arrow_left</mat-icon>
			</button>
			<button *ngIf="podeRolarMenuParaDireita" type="button" class="menu-scroll-control mobile-menu-scroll-control menu-scroll-right"
				(mouseenter)="iniciarRolagemMenuHorizontal(1)" (mouseleave)="pararRolagemMenu()"
				aria-label="Rolar menu para a direita">
				<mat-icon>keyboard_arrow_right</mat-icon>
			</button>
		</div>
		<button *ngIf="podeRolarMenuParaCima" type="button" class="menu-scroll-control menu-scroll-up"
			(mouseenter)="iniciarRolagemMenu(-1)" (mouseleave)="pararRolagemMenu()"
			aria-label="Rolar menu para cima">
			<mat-icon>keyboard_arrow_up</mat-icon>
		</button>
		<button *ngIf="podeRolarMenuParaBaixo" type="button" class="menu-scroll-control menu-scroll-down"
			(mouseenter)="iniciarRolagemMenu(1)" (mouseleave)="pararRolagemMenu()"
			aria-label="Rolar menu para baixo">
			<mat-icon>keyboard_arrow_down</mat-icon>
		</button>
		
		<div *ngIf="name" class="profile-divider mobile-only" aria-hidden="true"></div>
		<button *ngIf="name" class="avatar mobile-only" mat-icon-button (click)="abrirMenuPerfil()" matTooltip="Perfil">
			<img *ngIf="fotoPerfilDisponivel" [src]="'/api/Usuarios/MinhaFotoPerfil?v=' + fotoPerfilVersao" (error)="onErroFotoPerfil()" alt="">
			<span *ngIf="!fotoPerfilDisponivel">{{ iniciaisUsuario() }}</span>
		</button>
	</div>
	<div class="content-wrapper">
		<header>
			<button mat-button (click)="onClickSistemas()">
				<img class="sistemas-img" src="../assets/img/sistemas.png">
				<span class="sistemas">Sistemas</span>
			</button>
			<span class="spacer"></span>
			<span *ngIf="name" class="username">{{ name }}</span>
			<button *ngIf="name" class="avatar" mat-icon-button (click)="abrirMenuPerfil()" matTooltip="Perfil">
				<img *ngIf="fotoPerfilDisponivel" [src]="'/api/Usuarios/MinhaFotoPerfil?v=' + fotoPerfilVersao" (error)="onErroFotoPerfil()" alt="">
				<span *ngIf="!fotoPerfilDisponivel">{{ iniciaisUsuario() }}</span>
			</button>
		</header>
		<div *ngIf="redAlert" class="red-alert">
			ESTE É UM SISTEMA DE TESTES, NÃO O UTILIZE PARA OUTRO FIM
		</div>
		<main>
			<div class="router">
				<router-outlet></router-outlet>
			</div>
		</main>
	</div>
</ng-template>

<ng-template #routesElse>
	<main class="spinner-container">
		<mat-spinner></mat-spinner>
	</main>
</ng-template>
